import React from 'react';
import { useFormikContext } from 'formik';
import { Input, RadioGroup, Section } from '../Shared';
import { CITING_SECTION_TITLE } from './constants';
import { INTERVIEWED_DATE_FIELD_NAME, INTERVIEWED_DATE_KEY, INTERVIEWED_DATE_LABEL, INTERVIEWED_DATE_TEST_ID, INTERVIEW_TITLE_INPUT_LABEL, INTERVIEW_TITLE_INPUT_TEST_ID, MediumOptions, MEDIUM_RADIO_INPUT_LABEL, MEDIUM_RADIO_INPUT_TEST_ID, MethodOptions, METHOD_RADIO_INPUT_LABEL, METHOD_RADIO_INPUT_TEST_ID, SourceOptions, SOURCE_RADIO_INPUT_LABEL, SOURCE_RADIO_INPUT_TEST_ID, TabHeaders } from '../../forms/interview/constants';
import { PubDate } from '../Shared/PubDate';

/** interview citing section id and testId */
export var SECTION_ID = 'interview-citing-section';
export var SECTION_TEST_ID = 'interview-citing-section-test-id';
export var InterviewCiting = function InterviewCiting(_ref) {
  var _values$interview;
  var selectedTab = _ref.selectedTab;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var METHOD = (_values$interview = values.interview) === null || _values$interview === void 0 ? void 0 : _values$interview.type;
  var handleMethodRadioChange = function handleMethodRadioChange() {
    if (METHOD !== 'other') {
      setFieldValue('interview.how', '');
      setFieldValue('pubtype.suffix', '');
      INTERVIEWED_DATE_FIELD_NAME.forEach(function (value) {
        return setFieldValue(value, '');
      });
    }
  };
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(SECTION_ID, "-label"),
    dataTestId: SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    options: MethodOptions,
    legend: METHOD_RADIO_INPUT_LABEL,
    name: "".concat(selectedTab, ".interview.type"),
    formikFieldName: "interview.type",
    align: "horizontal",
    "data-test": METHOD_RADIO_INPUT_TEST_ID,
    defaultSelectedIndex: 1,
    onChange: handleMethodRadioChange
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "interview.title",
    labelText: INTERVIEW_TITLE_INPUT_LABEL,
    "data-test": INTERVIEW_TITLE_INPUT_TEST_ID
  }), METHOD === 'other' ? selectedTab === TabHeaders.MAGAZINE || selectedTab === TabHeaders.NEWSPAPER ? /*#__PURE__*/React.createElement(RadioGroup, {
    options: SourceOptions,
    legend: SOURCE_RADIO_INPUT_LABEL,
    name: "".concat(selectedTab, ".pubtype.suffix"),
    formikFieldName: "pubtype.suffix",
    align: "horizontal",
    "data-test": SOURCE_RADIO_INPUT_TEST_ID
  }) : null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PubDate, {
    key: INTERVIEWED_DATE_KEY,
    labelText: INTERVIEWED_DATE_LABEL,
    "data-test": INTERVIEWED_DATE_TEST_ID,
    isRecommended: false,
    formikFieldNames: INTERVIEWED_DATE_FIELD_NAME
  }), /*#__PURE__*/React.createElement(RadioGroup, {
    options: MediumOptions,
    legend: MEDIUM_RADIO_INPUT_LABEL,
    name: "".concat(selectedTab, ".interview.how"),
    formikFieldName: "interview.how",
    align: "horizontal",
    "data-test": MEDIUM_RADIO_INPUT_TEST_ID
  })));
};